/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type InventoryFiltersStatusItem = (typeof InventoryFiltersStatusItem)[keyof typeof InventoryFiltersStatusItem];

export const InventoryFiltersStatusItem = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
} as const;
